import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ClassroomPresenceUser } from "../models/classroom-presence-user";

export const ClassroomPresenceActions = createActionGroup({
    source: 'ClassroomPresence',
    events: {
        'loadClassroomPresence': emptyProps(),
        'loadClassroomPresenceFailed': emptyProps(),
        'loadClassroomPresenceSuccess': props<{ clients: ClassroomPresenceUser[] }>(),
        'userConnected': props<{ client: ClassroomPresenceUser }>(),
        'userDisconnected': props<{ client: ClassroomPresenceUser }>(),

        'pingUser': props<{ client: ClassroomPresenceUser }>(),
        'pingUserSuccess': props<{ client: ClassroomPresenceUser, isOnline: boolean }>(),
        'pingUserFailed': props<{ err: any }>(),

        'noop': emptyProps(),
  }
});
